const MODEL_INFORMATION = {
    numWatersheds: '104',
    meanError: '0.0',
    medianError: '0.0',
    meanAbsoluteError: '13.0',
    watershedsWithin20Percent: '76.0',
    climateDriverYears: '1961-1990',
};

module.exports = {
    MODEL_INFORMATION,
};
